import React from "react";

export default class ProductRow extends React.PureComponent {
  render() {
    const { product, selected, clickHandler, delay } = this.props;
    const imgSrc = "assets/images/company/";
    return (
      <div className="col-1-5">
        <figure
          className={
            product.name === selected.name
              ? "product-selected wow fadeInLeft"
              : "wow fadeInLeft"
          }
          data-wow-duration="500ms"
          data-wow-delay={delay + "ms"}
          onClick={clickHandler.bind(null, product)}
        >
          <div className="img-wrapper">
            <img
              src={imgSrc + product.logo}
              className="img-responsive"
              alt=""
              title={product.name}
            />
            <div className="overlay" title={product.name}></div>
          </div>
        </figure>
      </div>
    );
  }
}
